import React from 'react';
import { useState, useEffect } from 'react';
import { Alert, Card, CardContent, TextField, MenuItem, Select } from '@mui/material';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';
import { showNotification } from '../../../redux/slices/notificationSlice';
import CustomButton from '../../../componentsII/Buttons';
import api from '../../../axios/api';

const schema = yup.object().shape({
  vehicleMakeName: yup
    .string()
    .required('vehicle Make name is required')
    .min(2, 'Vehicle Make name must be at least 2 characters long')
    .max(50, 'Vehicle Make name must be less than 50 characters')
    .trim()
});

const AddUpdateVehicleMakeModal = ({ refetch, onClose, vehicleMakeId = null, initialData = null }) => {
  const dispatch = useDispatch();
  
  // Form states
  const [vehicleMakeName, setVehicleMakeName] = useState(initialData?.make_name || '');

  // UI states
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({
   vehicleMakeName: ''
  });

  const validateForm = async () => {
    try {
      await schema.validate({ 
        vehicleMakeName
      }, { abortEarly: false });
      return true;
    } catch (err) {
      const newErrors = {};
      err.inner.forEach((error) => {
        newErrors[error.path] = error.message;
      });
      setErrors(prevErrors => ({
        ...prevErrors,
        ...newErrors
      }));
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({vehicleMakeName:'' });

    const isValid = await validateForm();
    if (!isValid) return;

    try {
      setIsSubmitting(true);


      const payload = {
        vehicleMakeId: vehicleMakeId || 0,
        vehicleMakeName: vehicleMakeName.trim(),
      };

      const response = await api.post('/admin/createUpdateVehicleMake', payload);
      
      if (response.data.status === '200') {
        dispatch(showNotification({ 
          message: response.data.message, 
          type: "success" 
        }));
        onClose();
        refetch();
      } else {
        setErrors(prev => ({
          ...prev,
          general: response.data.message || 'Something went wrong'
        }));
      }
    } catch (err) {
      setErrors(prev => ({
        ...prev,
        general: err.message || 'An error occurred while saving'
      }));
      dispatch(showNotification({ 
        message: err.message || 'An error occurred', 
        type: "error" 
      }));
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <Card className="w-full mx-auto">
    <CardContent>
      <form onSubmit={handleSubmit} className="space-y-4">

        <div className="space-y-2">
          <label htmlFor="subIndustryName" className="text-sm font-medium">
            Vehicle Make Name
          </label>
          <TextField
            id="vehicleMakeName"
            value={vehicleMakeName}
            onChange={(e) => setVehicleMakeName(e.target.value)}
            placeholder="Enter sub-industry name"
            disabled={isSubmitting}
            size="small"
            error={Boolean(errors.vehicleMakeName)}
            className="w-full"
          />
          {errors.vehicleMakeName && (
            <p className="text-sm text-red-500 mt-1">{errors.vehicleMakeName}</p>
          )}
        </div>

        <div className="flex justify-end gap-5 items-center mt-5">
          <CustomButton
            className="bg-gray-500 hover:bg-gray-700 text-white"
            text="Cancel"
            click={onClose}
            disabled={isSubmitting}
          />
          <CustomButton
            className="bg-green-600 hover:bg-green-700 text-white"
            text={vehicleMakeId ? "Update" : "Submit"}
            type="submit"
            disabled={isSubmitting}
          />
        </div>
      </form>
    </CardContent>
  </Card>
  )
}

export default AddUpdateVehicleMakeModal